import React, { useState } from 'react'
import moment from 'moment';
import { RadioButton  } from 'primereact/radiobutton';
import { useEffect } from 'react';
const { $ } = window;
const ModalPromoPO = ({listPromo, withCode, onHandleClick, qty, onChangeQty, kuota}) => {
    const [state, setState] = useState({
        position: 1,
        item:[],
        selectedRow: {},
        _listPromo: [],
        max_qty: 0,
        min_qty: 1,
        _qty : 0,
    });

    const { position, item, selectedRow, _listPromo, max_qty, min_qty, _qty } = state;

    useEffect(_ =>{
        const index = listPromo.findIndex(e => e.checked);
        setState({...state, _listPromo: listPromo, _qty: qty, max_qty: kuota, selectedRow: listPromo[index] });
    },[qty, listPromo])

    const changePosition = (position, item) => {
        setState({...state, position, item});
    }

    const onChangeHandler=(e, row)=>{
        let filteredArray = [];
        filteredArray =  _listPromo;
        for(const key in filteredArray){
            filteredArray[key].checked = false;
        }
        const index = filteredArray.findIndex(e => e.paketid == row.paketid);
        if(index > -1) {
            filteredArray[index].checked = e.target.checked;
        }

        if(_qty > row.kuota ){
            _qty = row.kuota;
        }

        if(e.target.checked) {
            setState({...state, selectedRow: row, _listPromo: filteredArray, max_qty: row.kuota, _qty});
        }
    }

    const onClear = () => {
        setState({...state, selectedRow: {}});
        $('[name="radio"]').prop('checked', false);
    }

    
    
    return position == 1
    ? 
    <>
        <div className="modal-header">
            <h5 className="modal-title" style={{ fontWeight: '600' }}> Promo Product</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className='modal-body' style={{paddingLeft: 35,paddingRight: 35 }}>
            { withCode && 
            <>
                <p style={{ fontSize: 18, fontWeight: '500' }}>Promo Code</p>
                <div className='row'>
                    <div className="col-sm-12">
                        <div className="input-group input-group-button">
                            <input type="text" className="form-control form-input-promo" placeholder='Promo' />
                            <div className="input-group-prepend" style={{ position: 'absolute', top: 5, right: 5, zIndex: 10 }}>
                                <span className="input-group-text btn btn-modena" id="basic-addon10" style={{ borderRadius: 5 }}>
                                    <span className="">Apply</span>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                <hr />
            </>
            }
            { _listPromo && _listPromo.length > 0 ?
                <>
                    {_listPromo.map((row, index) => (
                        <div className='row' key={`promo-` + index}>
                            <div className="col-sm-1">
                                <div className="radio radiofill radio-primary radio-inline">
                                    <label>
                                        <RadioButton value={row.paketid} name="radio" onChange={(e) => onChangeHandler(e, row)} checked={row.checked} />
                                        {/* <input type="radio" className='radio-helper' name="radio" value={row.paketid} onChange={(e) => onChangeHandler(e, row)} /> */}
                                    </label>
                                </div>
                            </div>
                            <div className="col-sm-11">
                                <p style={{ fontWeight: 700, marginBottom: 0 }}>{row.paketid} 
                                    <span className="badge bg-red me-2" style={{width: 50, marginLeft: 10}}>{row.kuota}</span>
                                </p>
                                <p style={{ marginBottom: 0 }}>{row.keterangan_paket}... 
                                </p>
                                <p>
                                    <span style={{fontWeight: 500, cursor: 'pointer', textDecoration: 'underline'}} onClick={() => changePosition(2, row)}>Lihat Detail</span> 
                                </p>
                            </div>
                        </div>
                    ))}
                    { qty > 0 && 
                    <>
                        <hr />
                        <div className='col-sm-12'>
                            <div class="form-group row">
                                <label for="inputEmail3" class="col-sm-2 col-form-label">Qty</label>
                                <div class="col-sm-10">
                                    <input type="number" class="form-control" value={_qty} onChange={(e)=> onChangeQty(e, selectedRow)} max={max_qty} min={min_qty}  />
                                </div>
                            </div>
                        </div>
                    </>
                    }
                    <hr />
                    <div className='row' style={{ justifyContent: 'flex-end' }}>
                        <div className='col-sm-6'>
                            <button className="btn btn-readonly btn-block" style={{ marginBottom: 30 }} type="button" onClick={onClear}>
                                Clear
                            </button>
                        </div>
                        <div className='col-sm-6'>
                            <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={()=> onHandleClick(selectedRow)}>
                                Use
                            </button>
                        </div>

                    </div>
                </>
                :
                <>
                    <h5>Data not found...</h5>
                </>
            } 
        </div>
    </>
    : 
    <>
        <div className="modal-header">
            <h5 className="modal-title" style={{ fontWeight: '600' }}><span className='fa fa-arrow-left' style={{cursor:'pointer'}} onClick={() => changePosition(1)}></span> &nbsp; Promo Product</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className="modal-body">
            <div className='row'>
                <div className="col-sm-8">
                    {item.paketid}<br/>
                    {item.keterangan_campaign}
                </div>
                <div className="col-sm-4">
                    <p style={{marginBottom: 0}}>Expired</p>
                    <p style={{ fontWeight: 500 }}>{moment(item.akhir).format('DD MMM YYYY')}</p>
                    {/* <p>{row.keterangan_paket}... <span style={{fontWeight: 500, cursor: 'pointer'}} onClick={() => changePosition(2)}>Lihat Detail</span> </p> */}
                </div>
            </div>
            <p>{item.keterangan_paket}</p>
        </div>
    </>
}

export default ModalPromoPO